<script lang="ts">
  import type { FocusTarget } from '../app';
  import { lang, t } from '../i18n';
  import { focus, follow, followTarget, stopFollowing } from '../state/stores';
  import Icon from './icons/Icon.svelte';

  let { targets }: { targets: Map<string, FocusTarget> } = $props();

  const focused = $derived(targets.get($focus));
  const followed = $derived($followTarget ? targets.get($followTarget) : undefined);
</script>

{#if followed}
  <button
    type="button"
    class="panel pill following"
    aria-label={$t('follow.stop', { name: followed.name[$lang] })}
    onclick={stopFollowing}
  >
    <span class="dot" aria-hidden="true"></span>
    {$t('follow.active', { name: followed.name[$lang] })}
    <Icon name="close" size={16} />
  </button>
{:else if focused?.kind === 'spacecraft'}
  <button
    type="button"
    class="panel pill"
    aria-label={$t('follow.startLabel', { name: focused.name[$lang] })}
    onclick={() => follow(focused.id)}
  >
    {$t('follow.startLabel', { name: focused.name[$lang] })} <kbd aria-hidden="true">F</kbd>
  </button>
{/if}

<style>
  .pill {
    min-height: var(--touch);
    padding: 0 14px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: var(--track-caps);
    text-transform: uppercase;
    transition:
      border-color var(--dur-fast) var(--ease),
      color var(--dur-fast) var(--ease);
  }
  .pill:hover {
    border-color: var(--accent);
  }
  .following {
    border-color: var(--accent);
  }
  .dot {
    width: 10px;
    height: 10px;
    background: var(--accent);
  }
  kbd {
    font-family: var(--font-mono);
    font-size: 0.75rem;
    padding: 0 5px;
    border: 1px solid var(--fg-muted);
    color: var(--fg-muted);
  }
</style>
